import * as $ from 'jquery';
import 'bootstrap';
import * as Cookies from 'js-cookie';
import {bookingFormCommon} from './c005-bookingform-common';

export class stayIBEForm {
	private bcommon = new bookingFormCommon();

	$scope: any = $('#ibe-stay--container');
	$scopeMob: any = $('#mob-stay--container');

	nav(): void {
		let _self = this;
		let bcommon = _self.bcommon;
		let $mabHeader:any = $('#mab-header');

		let $bookFlight  : any = $('#book-flight--container');
		let $checkIn     : any =  $('#check-in--container');
		let $viewBooking : any = $('#view-booking--container');
		let $flightStatus: any = $('#flight-status--container');
		let $mhUpgrade   : any = $('#mhupgrade-in--container');
		let $login       : any = $('#login-container');
		let $loggedin    :any = $('#logged-in-user-menu');
		let $scopeStayMob: any = $('#mob-stay--container');

		let $bookFlightMob  : any = $('#mobile-bookflight--container');
		let $checkInMob     :any = $('#mob-checkin--container');
		let $viewBookingMob : any = $('#mob-viewbooking--container');
		let $flightStatusMob: any = $('#mob-flightstatus--container');
		let $mhUpgradeMob   : any = $('#mob-mhupgrade--container');
		let $loginMob       : any = $('#mob-login--container');
		let $loggedinMob    : any = $('#mob-logged-in-user-menu');
		let $mhHolidays : any = $('#mholiday-ibe--container');  
		let $mobMholidays  : any = $('#mobile-mholidays--container');
		let $flightUpgrade : any = $('#view-upgrade');

		let $ibeNav      : any = $('#bookingNav');
		let $ibeNavList  : any = $('#bookingNav li');
		let $bannerHeight: any = $('.img-holder').height();

		let $navOverlay: any = $('.mab-nav--overlay');
		let $mobIbeNav : any = $('#mab-bookingnav.mobile #bookingNav');
		let $bookingNavLinks : any = $('#mab-bookingnav .navbar-nav li a');

		let countryCookie:any = Cookies.get('session-selected-language');

		if (countryCookie === 'vi' || countryCookie === 'id') {
			$bookingNavLinks.addClass('longCharLength');
		}

		// IBE Navigation show/hide Check in container
		$ibeNav.find('.ibe-stay').on('click', () =>{
			$ibeNav.find('li').removeClass('selected');
			$ibeNav.find('.ibe-stay').parent().addClass('selected');
			if($('#b_container').is(':empty')) {
				_self.init3rdPartyScript();
			}
			_self.$scope.show();
			$flightUpgrade.hide();
			$bookFlight.hide();
			$checkIn.hide();
			$viewBooking.hide();
			$flightStatus.hide();
			$mhUpgrade.hide();
			$login.hide();
			$mhHolidays.hide();
			$loggedin.addClass('hidden');

			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$mhUpgradeMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
		});


		// Overlay container - IBE Navigation show/hide Mobile Check in container
		$navOverlay.find('.mobile-stay').on('click', () =>{
			$ibeNavList.removeClass('selected');
			$mobIbeNav.find('.mobile-stay').parent().addClass('selected');
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$mhUpgradeMob.hide();
			bcommon.scrollToTopIBE();
			$mobMholidays.hide();			
			if (window.innerWidth > 767 && window.innerWidth < 1200) {
				$ibeNav.find('li').removeClass('selected');
				$ibeNav.find('.ibe-stay').parent().addClass('selected');
				if ($('#b_container').is(':empty')) {
					_self.init3rdPartyScript();
				}
				_self.$scope.show();
				$bookFlight.hide();
				$checkIn.hide();
				$viewBooking.hide();
				$flightStatus.hide();
				$mhUpgrade.hide();
				$login.hide();
				$mhHolidays.hide();
				$loggedin.addClass('hidden');

				_self.$scopeMob.show();
				$bookFlightMob.hide();
				$checkInMob.hide();
				$viewBookingMob.hide();
				$flightStatusMob.hide();
				$mhUpgradeMob.hide();
				$loginMob.hide();
				$loggedinMob.hide();
			}
		});
	}

	hotelBookingRental(): void {
		let _self = this;
		let $hotelBooking:any = $('#b_container');
		let $carrental:any    = $('#carrental_container');
		$carrental.show();
		$hotelBooking.hide();
		$('.ibe-hotel').click(() =>{
			$hotelBooking.show();
			$carrental.hide();
			_self.$scope.find('.hotel-rental li').removeClass('selected');
			_self.$scope.find('.ibe-hotel').parent().addClass('selected');
		});

		$('.ibe-car--rental').click(() =>{
			$carrental.show();
			$hotelBooking.hide();
			_self.$scope.find('.hotel-rental li').removeClass('selected');
			_self.$scope.find('.ibe-car--rental').parent().addClass('selected');
		});
	}

	mobHotelBookingRental(): any{
		let _self = this;
		let $hotelBooking:any = $('.mobile-stay');
		let $carrental:any    = $('.mobile-rental');

		$carrental.show();
		//$hotelBooking.hide();

		$('.ibe-hotel').click(() =>{
			$hotelBooking.show();
			$carrental.hide();
			_self.$scopeMob.find('.hotel-rental li').removeClass('selected');
			_self.$scopeMob.find('.ibe-hotel').parent().addClass('selected');
		});

		$('.ibe-car--rental').click(() =>{
			$carrental.show();
			$hotelBooking.hide();
			_self.$scopeMob.find('.hotel-rental li').removeClass('selected');
			_self.$scopeMob.find('.ibe-car--rental').parent().addClass('selected');
		});
	}

	init3rdPartyScript(): void {
		let _self = this;
 		let scriptSrc:string = _self.$scope.attr('data-script-url');
 		let scriptEl:any = document.createElement('script');

 		scriptEl.setAttribute('src', scriptSrc);
 		scriptEl.setAttribute('defer', 'defer');
 		scriptEl.setAttribute('id', _self.$scope.attr('data-id'));
 		scriptEl.setAttribute('data-hash', _self.$scope.attr('data-hash'));
 		scriptEl.setAttribute('data-container', _self.$scope.attr('data-container'));
 		scriptEl.setAttribute('data-size', _self.$scope.attr('data-size'));
 		scriptEl.setAttribute('data-tpncy', _self.$scope.attr('data-tpncy'));

 		document.body.appendChild(scriptEl);
	}

	/**
	 * @function initiFrames
	 * on document.ready, switch data-src of iframe to src so iframes only load after for better performance.
	 */
	initiFrames(): void {
		let _self = this;
		let deskIframes = _self.$scope.find('iframe[data-src]');
		let mobIframes = _self.$scopeMob.find('iframe[data-src]');

		function swapDataToSrc(el:any) {
			let $el:any = $(el);
			let dataSrc:string = $el.attr('data-src');

			// write iframe src from data-attr
			$el.attr({
				'src': dataSrc
			});

			// remove data-attr after writing
			$el.removeAttr('data-src');

			return;
		}

		deskIframes.each(function(i:number) {
			swapDataToSrc(this);
		});

		mobIframes.each(function(i:number) {
			swapDataToSrc(this);
		});
	}	
}

let scope:Element = document.querySelector('#ibe-stay--container');
if (scope){
	try {
		let stayibeform = new stayIBEForm();
				stayibeform.nav();
				stayibeform.hotelBookingRental();
				stayibeform.mobHotelBookingRental();				
				$(document).ready(function(){
						stayibeform.init3rdPartyScript();
						stayibeform.initiFrames();
				});
	} catch(e) {console.error(e);}
}
